import { render } from "./PrivacyPolicy.vue?vue&type=template&id=e136d02e&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"

import "./PrivacyPolicy.vue?vue&type=style&index=0&id=e136d02e&lang=scss&scoped=true"

import exportComponent from "/var/www/nexgen/apps/nxglabs-web/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e136d02e"]])

export default __exports__